// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.slack-steps {
  margin: 4px 0 22px 0;
  border-radius: 12px;
  border-left: 4px solid #611f69;
  background-color: #faf5fb;
  overflow: hidden;
  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04);
}

.slack-step {
  display: flex;
  align-items: flex-start;
  gap: 14px;
  padding: 14px 18px;
  font-size: 0.93rem;
  color: #2d2d2d;
  line-height: 1.55;
}

.slack-step + .slack-step {
  border-top: 1px solid #ead7ec;
}

/* Outer SVG box for the numbered step badge. The circle + digit live inside
   the SVG so they're truly centered (see SlackConnectModal.js comments). */
.slack-step-num {
  flex-shrink: 0;
  display: block;
  width: 26px;
  height: 26px;
  margin-top: 1px;
}

.slack-step-body {
  flex: 1 1;
  min-width: 0;
}

.slack-step code {
  background-color: #ffffff;
  border: 1px solid #ead7ec;
  border-radius: 5px;
  padding: 1px 6px;
  font-family: 'SFMono-Regular', Menlo, Consolas, 'Courier New', monospace;
  font-size: 0.84em;
  color: #611f69;
}

.slack-step a {
  color: #611f69;
  text-decoration: none;
  font-weight: 600;
}

.slack-step a:hover {
  text-decoration: underline;
}

/* Manifest JSON block: monospace, scrollable, with a Copy button overlay. */
.slack-manifest-block {
  position: relative;
  margin-top: 10px;
  border: 1px solid #ead7ec;
  border-radius: 8px;
  background-color: #ffffff;
}

.slack-manifest-pre {
  margin: 0;
  padding: 12px 14px;
  padding-right: 70px; /* leave room for the Copy button */
  font-family: 'SFMono-Regular', Menlo, Consolas, 'Courier New', monospace;
  font-size: 0.78rem;
  line-height: 1.5;
  color: #333;
  background-color: transparent;
  white-space: pre;
  overflow-x: auto;
  max-height: 220px;
  overflow-y: auto;
}

.slack-manifest-copy-btn {
  position: absolute;
  top: 8px;
  right: 8px;
  border: 1px solid #611f69;
  background-color: #ffffff;
  color: #611f69;
  padding: 4px 10px;
  border-radius: 6px;
  font-size: 0.78rem;
  font-weight: 600;
  cursor: pointer;
  transition: background-color 0.15s ease, color 0.15s ease;
}

.slack-manifest-copy-btn:hover {
  background-color: #611f69;
  color: #ffffff;
}

.slack-token-field input {
  letter-spacing: 0.02em;
}

/* Token / signing-secret inputs that sit inside a step body get a bit of
   breathing room from the instruction text above them. */
.slack-step-input {
  margin-top: 10px !important;
}

.slack-error {
  margin-top: 14px;
  padding: 10px 12px;
  background-color: #fdecea;
  border-radius: 8px;
  border-left: 4px solid #e53935;
  color: #611a15;
  font-size: 0.9rem;
  line-height: 1.4;
}
`, "",{"version":3,"sources":["webpack://./src/components/SlackConnectModal.css"],"names":[],"mappings":"AAAA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,8BAA8B;EAC9B,yBAAyB;EACzB,gBAAgB;EAChB,4CAA4C;AAC9C;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;2EAC2E;AAC3E;EACE,cAAc;EACd,cAAc;EACd,WAAW;EACX,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,SAAO;EACP,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,wEAAwE;EACxE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA,4EAA4E;AAC5E;EACE,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,mBAAmB,EAAE,mCAAmC;EACxD,wEAAwE;EACxE,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;EACX,6BAA6B;EAC7B,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,yBAAyB;EACzB,yBAAyB;EACzB,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,yDAAyD;AAC3D;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;yDACyD;AACzD;EACE,2BAA2B;AAC7B;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,8BAA8B;EAC9B,cAAc;EACd,iBAAiB;EACjB,gBAAgB;AAClB","sourcesContent":[".slack-steps {\r\n  margin: 4px 0 22px 0;\r\n  border-radius: 12px;\r\n  border-left: 4px solid #611f69;\r\n  background-color: #faf5fb;\r\n  overflow: hidden;\r\n  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04);\r\n}\r\n\r\n.slack-step {\r\n  display: flex;\r\n  align-items: flex-start;\r\n  gap: 14px;\r\n  padding: 14px 18px;\r\n  font-size: 0.93rem;\r\n  color: #2d2d2d;\r\n  line-height: 1.55;\r\n}\r\n\r\n.slack-step + .slack-step {\r\n  border-top: 1px solid #ead7ec;\r\n}\r\n\r\n/* Outer SVG box for the numbered step badge. The circle + digit live inside\r\n   the SVG so they're truly centered (see SlackConnectModal.js comments). */\r\n.slack-step-num {\r\n  flex-shrink: 0;\r\n  display: block;\r\n  width: 26px;\r\n  height: 26px;\r\n  margin-top: 1px;\r\n}\r\n\r\n.slack-step-body {\r\n  flex: 1;\r\n  min-width: 0;\r\n}\r\n\r\n.slack-step code {\r\n  background-color: #ffffff;\r\n  border: 1px solid #ead7ec;\r\n  border-radius: 5px;\r\n  padding: 1px 6px;\r\n  font-family: 'SFMono-Regular', Menlo, Consolas, 'Courier New', monospace;\r\n  font-size: 0.84em;\r\n  color: #611f69;\r\n}\r\n\r\n.slack-step a {\r\n  color: #611f69;\r\n  text-decoration: none;\r\n  font-weight: 600;\r\n}\r\n\r\n.slack-step a:hover {\r\n  text-decoration: underline;\r\n}\r\n\r\n/* Manifest JSON block: monospace, scrollable, with a Copy button overlay. */\r\n.slack-manifest-block {\r\n  position: relative;\r\n  margin-top: 10px;\r\n  border: 1px solid #ead7ec;\r\n  border-radius: 8px;\r\n  background-color: #ffffff;\r\n}\r\n\r\n.slack-manifest-pre {\r\n  margin: 0;\r\n  padding: 12px 14px;\r\n  padding-right: 70px; /* leave room for the Copy button */\r\n  font-family: 'SFMono-Regular', Menlo, Consolas, 'Courier New', monospace;\r\n  font-size: 0.78rem;\r\n  line-height: 1.5;\r\n  color: #333;\r\n  background-color: transparent;\r\n  white-space: pre;\r\n  overflow-x: auto;\r\n  max-height: 220px;\r\n  overflow-y: auto;\r\n}\r\n\r\n.slack-manifest-copy-btn {\r\n  position: absolute;\r\n  top: 8px;\r\n  right: 8px;\r\n  border: 1px solid #611f69;\r\n  background-color: #ffffff;\r\n  color: #611f69;\r\n  padding: 4px 10px;\r\n  border-radius: 6px;\r\n  font-size: 0.78rem;\r\n  font-weight: 600;\r\n  cursor: pointer;\r\n  transition: background-color 0.15s ease, color 0.15s ease;\r\n}\r\n\r\n.slack-manifest-copy-btn:hover {\r\n  background-color: #611f69;\r\n  color: #ffffff;\r\n}\r\n\r\n.slack-token-field input {\r\n  letter-spacing: 0.02em;\r\n}\r\n\r\n/* Token / signing-secret inputs that sit inside a step body get a bit of\r\n   breathing room from the instruction text above them. */\r\n.slack-step-input {\r\n  margin-top: 10px !important;\r\n}\r\n\r\n.slack-error {\r\n  margin-top: 14px;\r\n  padding: 10px 12px;\r\n  background-color: #fdecea;\r\n  border-radius: 8px;\r\n  border-left: 4px solid #e53935;\r\n  color: #611a15;\r\n  font-size: 0.9rem;\r\n  line-height: 1.4;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
